import { useFormContext, Controller } from "react-hook-form";

import EmploymentTypeSelect from "./EmploymentTypeSelect";

const EmploymentTypeField = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext();

  return (
    <>
      <label
        htmlFor="employment-type"
        className="block text-sm font-medium leading-5 text-gray-900"
      >
        Arbeitsverhältniss
      </label>
      <Controller
        control={control}
        name="employmentType"
        render={({ field }) => <EmploymentTypeSelect {...field} />}
      />
    </>
  );
};

export default EmploymentTypeField;
